'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _AjaxCart = require('components/InlineCart/AjaxCart.js');

var _ProductTiles = require('scripts/sections/ProductTiles');

var _ProductTiles2 = _interopRequireDefault(_ProductTiles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var dom = {
  freeGiftATC: 'data-add-free-gift'
};

/**
 * Adds free gift and reloads the cart
 */
var addFreeGiftToCart = function addFreeGiftToCart(productToAdd) {

  CartJS.addItem(productToAdd, 1, { 'type': 'free-gift' }, {
    "success": function success(data, textStatus, jqXHR) {
      (0, _AjaxCart.fetchFullCart)();
      (0, _AjaxCart.fetchInlineCart)(true);
      // need to update CartJS cart object
      CartJS.getCart();
    }
  });
};

/**
 * Setup listener for the Free Gift Add To Cart Button
 */
var setup = function setup() {
  document.addEventListener('click', function (event) {
    var isFreeGiftATC = event.target.matches('[' + dom.freeGiftATC + ']') || false;
    if (isFreeGiftATC) {
      event.stopImmediatePropagation();
      var freeGiftId = Number(event.target.dataset['productId']);
      addFreeGiftToCart(freeGiftId);
    }
  });
};

exports.default = {
  setup: setup
};